<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gGUQ91/tc-custom/9781453260739.jpg?1703823896192" alt="This image is the cover for the book Kill the Dragon, The Narc Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kill the Dragon, The Narc Series
      </h1>
      <p class="bookDescription body article font2">
        <p class="MsoNormal"><b>Only Bolt can save New York from an alliance between the Chinese and Italian mobs</b></p><p class="MsoNormal">In a dank Chinatown gymnasium, a dragon prepares for the parade. As the teenagers inside the monster practice its ungainly walk, four Sun Eagles surround them and open fire. Trapped inside the dragon, the small-timers never have a chance. For the crime of stealing Sun Eagle heroin, they die on the gymnasium floor.</p><p class="MsoNormal">The hit puts the Sun Eagles at the top of the Chinatown heap, in position to strike the bargain that will make them rich. Sick of sitting on the sidelines in New York’s drug skirmishes, a mafia capo buys $4 million in Sun Eagle smack to use as a war chest in the bloodiest campaign the city’s streets have ever seen. Standing in his way is narcotics agent John Bolt, a one-man army who can match any dragon, Chinese or otherwise.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marc Olden
      </h2>
      
      <p class="authorDescription body article">Marc Olden (1933&ndash;2003) was the author of forty mystery and suspense novels. Born in Baltimore, he began writing while working in New York as a Broadway publicist. His first book,&#160;<I>Angela Davis</I>&#160;(1973), was a nonfiction study of the controversial Black Panther. In 1973 he also published&#160;<I>Narc</I>, under the name Robert Hawke, beginning a hard-boiled nine-book series about a federal narcotics agent.<P>A year later,&#160;<I>Black Samurai</I>&#160;introduced Robert Sand, a martial arts expert who becomes the first non-Japanese student of a samurai master. Based on Olden&rsquo;s own interest in martial arts, which led him to the advanced ranks of karate and aikido, the novel spawned a successful eight-book series. Olden continued writing for the next three decades, often drawing on his fascination with Japanese culture and history.&#160;</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55d3b110